export default {
  ADD_VOLUNTEER(state, payload) {
    state.volunteer = payload;
  },
};
